import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Cup, PlayButton } from '@swf/casino';
import InfoIcon from '@swf/core/assets/casino/info.svg';
import type { Dispatch } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { isRunning } from '@swf/core/utils/casino';

import RegisteredPlayers from '../RegisteredPlayers/RegisteredPlayers';

import { TXTCLI_OK } from './PlayBar.messages.json';
import styles from './PlayBar.scss';

export interface Props {
  race: CasinoRace;
  onLaunch(): void;
  onLeaderboard?(): void;
}

const PlayBar: React.FC<Props> = ({ onLeaderboard, race, onLaunch }) => {
  const { numOfPlayers, status, name, promoUrl } = race;
  const isLiveRace = isRunning(status);
  const { modal } = useDispatch<Dispatch>();

  const onInfo = useCallback(() => {
    modal.close('/casino/race-leaderboard');
    modal.enqueue({
      path: '/casino/help',
      locationState: {
        buttonTextTag: TXTCLI_OK,
        title: name,
        pathname: promoUrl
      }
    });
  }, [modal, name, promoUrl]);

  return (
    <div className={classNames(styles.play, { [styles.leaderboardPlay]: !onLeaderboard })}>
      <RegisteredPlayers {...{ isLiveRace, numOfPlayers }} />
      <div className={styles.playAction}>
        <div className={styles.expand}>
          {promoUrl && (
            <StarsButton
              variant="text"
              size="small"
              className={styles.infoIcon}
              onClick={onInfo}
              icon={<InfoIcon />}
            />
          )}
        </div>
        {!!onLeaderboard && (
          <div className={styles.expand}>
            <StarsButton
              variant="text"
              size="small"
              className={styles.cup}
              onClick={onLeaderboard}
              icon={<Cup />}
            />
          </div>
        )}
        <PlayButton race={race} onLeaderboard={onLeaderboard} onLaunch={onLaunch} />
      </div>
    </div>
  );
};

export default PlayBar;
